export const SchDistfeatures = [
  {
    imageUrl: '',
    title: 'Admin Dashboard',
    description:
      'Stay ahead of compliance requirements with our admin dashboard. Allows admins to monitor therapist data and student performance in real-time.',
    alt: 'Stay compliant with our admin dashboard. Real-time monitoring of therapist data and student performance.',
  },
  {
    imageUrl: '',
    title: 'Integrations with IEP systems',
    description:
      'We can integrate with your Student Information Systems and IEP systems and automatically pull in student demographic data and goals.',
    alt: 'Seamlessly integrate with your IEP and Student Information Systems',
  },
  {
    imageUrl: '',
    title: 'SSO',
    description:
      'We can integrate with most single sign on providers like Google, PowerSchool, Clever etc.',
    alt: 'Connect effortlessly with popular single sign-on (SSO) providers such as Google, PowerSchool, Clever, and more.',
  },
  {
    imageUrl: '',
    title: 'Multi provider collaborations',
    description:
      'Advanced collaboration between teachers and clinicians enabled',
    alt: 'Unlock advanced collaboration between teachers and clinicians',
  },
  {
    imageUrl: '',
    title: 'Training and Support',
    description:
      'Staff and admin training provided with every purchase. Live chat and email support available throughout the year.',
    alt: 'Comprehensive training and support included',
  },
];
